export default "__VITE_ASSET__DK6eatnV__"